import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import { WhitelabelSubjectApplication } from 'models/CustomDomains';
import CustomDomainModal from './CustomDomainModal';

export const CUSTOM_DOMAIN_MODAL_ID = 'custom-domain-modal';

interface OpenCustomDomainModalOptions {
  shouldMigrate?: boolean;
  hasSettings?: boolean;
  // omit to show every product; pass one to scope the modal to it
  applications?: (
    | WhitelabelSubjectApplication.PLATFORM
    | WhitelabelSubjectApplication.DBS
  )[];
}

// flags come from agency.jsp: the title is set at open time, before the fetch
const getTitleKey = ({
  shouldMigrate,
  hasSettings,
}: OpenCustomDomainModalOptions) => {
  if (shouldMigrate) {
    return 'componentCustomDomains.migrateModalTitle';
  }

  return hasSettings
    ? 'componentCustomDomains.editModalTitle'
    : 'componentCustomDomains.modalTitle';
};

const useOpenCustomDomainModal = () => {
  const { t } = useTranslation();
  const { openModal } = useAppModal();

  const openCustomDomainModal = useCallback(
    ({
      shouldMigrate,
      hasSettings,
      applications,
    }: OpenCustomDomainModalOptions = {}) => {
      openModal({
        id: CUSTOM_DOMAIN_MODAL_ID,
        title: t(getTitleKey({ shouldMigrate, hasSettings })),
        customContent: (
          <CustomDomainModal
            modalId={CUSTOM_DOMAIN_MODAL_ID}
            shouldMigrate={shouldMigrate}
            applications={applications}
          />
        ),
      });
    },
    [openModal, t],
  );

  return { openCustomDomainModal };
};

export default useOpenCustomDomainModal;
